<template>
	<main class="main" id="main" v-bind:class="theme">
		<div class="mycelium">
			<img v-bind:src="mycelium" alt="the mycelium" title="The Mycelium" />
		</div>
		<!-- end mycelium -->
		<div class="flex-container">
			<!-- GET SIDEBAR -->
			<div class="sidebar__wrapper" id="sidebarWrapper">
				<Sidebar @toggleSidebar="toggleSidebar"></Sidebar>
			</div>
			<!-- end sidebar__wrapper -->
			<!-- MAIN CONTENT -->
			<div class="main-content">
				<div class="container">
					<router-view></router-view>
				</div>
				<!-- end container -->
			</div>
			<!-- end main-content -->
		</div>
		<!-- end flex-container -->
	</main>
</template>

<script>
import {mapGetters} from "vuex"
import Sidebar from "./../components/sidebar/Sidebar.vue"

//let main = null
//let sidebarWrapper = null

export default {
	data() {
		return {
			theme: "dashboard admin has-sidebar blue-bg",
			mycelium: require("./../assets/img/mycelium.svg"),
		}
	},
	computed: {
		...mapGetters("views", ["getSidebarOpenState"]),
	},
	methods: {
		toggleSidebar() {
			this.$store.dispatch("views/toggleSidebar")
		},
	},
	components: {
		Sidebar,
	},
	mounted() {
		//main = document.getElementById("main")
		//sidebarWrapper = document.getElementById("sidebarWrapper")
	},
}
</script>
<style lang="scss">
@import "./src/assets/scss/dashboard.scss";
</style>
